/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<e12c48cf25fcdcbd09b0d108bdd1de9d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from "relay-runtime";
import type { FragmentRefs } from "relay-runtime";
export type portalsFragment$data = {
  readonly portals: ReadonlyArray<{
    readonly __typename: "HelpObjectStoreSearchResult";
    readonly description?: string;
    readonly displayLink?: string;
    readonly id?: string;
    readonly isExternal?: boolean;
    readonly message?: string | null;
    readonly title?: string;
    readonly " $fragmentSpreads": FragmentRefs<"resourceIconFragment">;
  } | null>;
  readonly " $fragmentType": "portalsFragment";
};
export type portalsFragment$key = {
  readonly " $data"?: portalsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"portalsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "queryTerm"
    },
    {
      "kind": "RootArgument",
      "name": "resultLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "portalsFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "portals",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "entityType",
                "value": "PORTAL"
              },
              {
                "kind": "Variable",
                "name": "queryTerm",
                "variableName": "queryTerm"
              },
              {
                "kind": "Variable",
                "name": "resultLimit",
                "variableName": "resultLimit"
              }
            ],
            "kind": "ObjectValue",
            "name": "searchInput"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "searchHelpObjects",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "portals.__typename"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "portals.id"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "portals.title"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "portals.description"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayLink",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "portals.displayLink"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isExternal",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "portals.isExternal"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "resourceIconFragment"
              }
            ],
            "type": "HelpObjectStoreSearchResult",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "HelpObjectStoreQueryError",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW",
      "path": "portals"
    }
  ],
  "type": "HelpObjectStoreQueryApi",
  "abstractKey": null
};

(node as any).hash = "e0fc78470b95b3a60dfa20bf6ec28265";

export default node;
